/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */
import { HttpClient, HttpErrorResponse, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { PropulsionTranDtl } from '../models/propulsion-tran-dtl.model';
import { ConfigService } from './config.service';
import { RemoveObsoleteRecordsService } from './remove-obsolete-records.service';

@Injectable({
  providedIn: 'root'
})
export class TranDtlService implements RemoveObsoleteRecordsService {

  constructor(private readonly configService: ConfigService,
              private readonly http: HttpClient) {
  }

  getObsoleteRecords(): Observable<PropulsionTranDtl[]> {
    return this.http.get<PropulsionTranDtl[]>(`${this.configService.baseApiUrl}tran-dtl/obsolete`).pipe(
      map((res) => res, catchError(myError => TranDtlService.handleError(myError))));
  }

  removeObsoleteRecords(): any {
    return this.http.delete(`${this.configService.baseApiUrl}tran-dtl/delete-obsolete`)
    .pipe(catchError(myError => TranDtlService.handleError(myError)));
  }

  private static handleError(errorResponse: HttpErrorResponse): any {
    let errorMessage = 'An unexpected error occurred';
    switch (errorResponse.status) {
      case HttpStatusCode.BadRequest: {
        if (errorResponse.error && errorResponse.error.message) {
          errorMessage = errorResponse.error.message;
        } else {
          errorMessage = 'Remove Obsolete Transmission Configuration failed.';
        }
        break;
      }
      case HttpStatusCode.Forbidden: {
        errorMessage = 'Unable to remove Obsolete Transmission Configuration.';
        break;
      }
    }
    return throwError(errorMessage);
  }
}
